import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import {
  TerminalUserModel,
  UpdateTerminalUserRequest,
} from '@models/terminal-user/terminal-user.model';
import { ResponseModel } from '@models/response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TerminalUserService {
  private readonly terminalUsersApi = `${environment.caisseApiUrl}/self-pos-terminal-users`;
  private readonly httpService = inject(HttpService);

  getTerminalUsers(terminalId: number): Observable<TerminalUserModel[]> {
    return this.httpService.get<TerminalUserModel[]>(
      this.terminalUsersApi + '/self-pos-terminal/' + terminalId,
    );
  }

  createTerminalUser(request: Omit<UpdateTerminalUserRequest, 'id'>): Observable<ResponseModel> {
    return this.httpService.post<ResponseModel, Omit<UpdateTerminalUserRequest, 'id'>>(
      this.terminalUsersApi,
      request,
    );
  }

  updateTerminalUser(request: UpdateTerminalUserRequest): Observable<ResponseModel> {
    return this.httpService.put<ResponseModel, UpdateTerminalUserRequest>(
      this.terminalUsersApi,
      request,
    );
  }
}
